export const TinkSymbol = ({
	width,
	height,
	fill,
}: {
	width: number;
	height: number;
	fill?: string;
}) => {
	const defaultFill = "#fff";
	return (
		<svg
			version="1.1"
			id="Lager_1"
			aria-hidden="true"
			focusable="false"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 99.2 170.1"
			enableBackground="new 0 0 99.2 170.1"
			xmlSpace="preserve"
			width={width}
			height={height}
		>
			<path
				fill={fill || defaultFill}
				className="st0"
				d="M0,37c20.4,0,37-16.6,37-37h29.6c0,36.8-29.8,66.6-66.6,66.6"
			/>
			<path
				fill={fill || defaultFill}
				className="st0"
				d="M99.1,170.1c-36.8,0-66.6-29.8-66.6-66.6S62.3,37,99.1,37v29.6c-20.4,0-37,16.6-37,37s16.6,37,37,37"
			/>
		</svg>
	);
};
